module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Baianat partners","pageDesc":"Partners we are proud to share the journey with in Baianat.","mantra":"Official partners |and collaborators."},"ar":{"pageTitle":"الشركاء","pageDesc":"شركاء نفخر بمشاركتهم رحلتنا في بيانات.","mantra":"الشركاء الرسميون |لبيانات. "}}')
  delete Component.options._Ctor
}
